import { render, staticRenderFns } from "./JEnumSelectTag.vue?vue&type=template&id=6d2b9128&scoped=true"
import script from "./JEnumSelectTag.vue?vue&type=script&lang=js"
export * from "./JEnumSelectTag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d2b9128",
  null
  
)

export default component.exports